var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7A9A01;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.82,437.67H97.66c-32.92,0-59.69-26.78-59.69-59.69V132.82c0-32.91,26.78-59.69,59.69-59.69h245.15 c32.92,0,59.69,26.78,59.69,59.69v245.15C402.51,410.89,375.73,437.67,342.82,437.67z M97.66,104.9 c-15.4,0-27.92,12.53-27.92,27.92v245.15c0,15.39,12.53,27.92,27.92,27.92h245.15c15.4,0,27.92-12.53,27.92-27.92V132.82 c0-15.39-12.53-27.92-27.92-27.92H97.66z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.94,347.62c-6.88,0-13.76-2.63-19.01-7.88L122.37,234.17c-10.5-10.5-10.5-27.52,0-38.02 c10.5-10.5,27.52-10.5,38.02,0l105.57,105.57c10.5,10.5,10.5,27.52,0,38.02C260.7,344.99,253.82,347.62,246.94,347.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.94,347.62c-6.88,0-13.76-2.63-19.01-7.88c-10.5-10.5-10.5-27.52,0-38.02L439.07,90.58 c10.5-10.5,27.52-10.5,38.02,0c10.5,10.49,10.5,27.52,0,38.02L265.95,339.74C260.7,344.99,253.82,347.62,246.94,347.62z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioOn);
export default __webpack_public_path__ + "static/media/radio_on.fc312991c37bf006afb7b567fe22f479.svg";
export { ForwardRef as ReactComponent };